var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrokenCloudsNightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.358,
    height: 24,
    viewBox: "0 0 24.358 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "broken-clouds-night-icon",
    transform: "translate(-121 -127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(121 127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 14,
    height: 14,
    transform: "translate(8 1)",
    fill: "rgba(252,252,252,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M19.16,6.833H17.94A4.73,4.73,0,0,0,9.909,4.825a3.289,3.289,0,0,0-.826,1.268,4.745,4.745,0,0,0,4.342,6.574h5.25A3,3,0,0,0,20.83,7.638a2.083,2.083,0,0,0-1.67-.8Z",
    fill: "none",
    stroke: "#364456",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(121 127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-2-2",
    "data-name": "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area-2",
    "data-name": "Area",
    width: 24,
    height: 24,
    fill: "rgba(252,252,252,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2-3",
    "data-name": "Icon-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M19.132,13H17.04C15.577,7.336,8.4,4.662,3.272,9.559a5.626,5.626,0,0,0-1.415,2.174C-.305,17.826,4.014,23,9.3,23h9c3.919,0,6.785-4.507,3.7-8.62A3.571,3.571,0,0,0,19.132,13Z",
    fill: "#fff",
    stroke: "#364456",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenCloudsNightIcon);
export default __webpack_public_path__ + "static/media/broken-clouds-night-icon.7af7fd73bd28b03f8a70d8c927785efa.svg";
export { ForwardRef as ReactComponent };